import { ProgramContactInfo } from "./program-contact-info";
import { ProgramDetails } from "./program-details";
import { ProgramServices } from "./program-services";
import { ProgramRequestSubmission } from "./program-request-submission";
export class Program {
    public id: number;
    public contactInfo: ProgramContactInfo;
    public details: ProgramDetails;
    public services: ProgramServices;
    public submit: ProgramRequestSubmission;
    public similarConfirmed: boolean;
    public displayCreatedDate: string;

    static communitySchoolsTooltip: string = "Community schools are a specific model of education that incorporate integrated student supports, " +
                                             "expanded learning time and opportunities, family and community engagement, and collaborative leadership and practices. " +
                                             "If you are unsure if you are a community school contact Faith Knocke knockef@actnowillinois.org.";
}


// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/program/program.ts